<template>
  <div>
    <div class="search-bar-margin-bottom-cla">
      <el-form :inline="true" :model="params">
        <el-form-item :label="$t('attendanceRecord.punchTime')">
          <el-date-picker
            class="pickData_cla"
            v-model="value2"
            type="daterange"
            @clear="searchFn"
            align="right"
            unlink-panels
            range-separator="-"
            :start-placeholder="$t('common.startTime')"
            :end-placeholder="$t('common.endTime')"
            :picker-options="pickerOptions"
          ></el-date-picker>
        </el-form-item>

        <el-form-item label="Sn">
          <el-input
            v-model.trim="params.deviceSn"
            clearable
            @clear="searchFn"
            @keyup.enter.native="searchFn"
            :placeholder="$t('device.sn')"
          ></el-input>
        </el-form-item>

        <el-form-item :label="$t('attendanceRecord.pin')">
          <el-input
            class="pin_cla"
            v-model.trim="params.pin"
            clearable
            @clear="searchFn"
            @keyup.enter.native="searchFn"
            :placeholder="$t('attendanceRecord.pin')"
          >
          </el-input>
        </el-form-item>
        <el-form-item>
          <el-button @click="searchFn" type="primary" icon="el-icon-search">{{
            $t('common.search')
          }}</el-button>
        </el-form-item>
        <!-- <el-form-item>
          <el-dropdown trigger="click" @command="handleCommand">
            <el-button class="el-dropdown-link" type="primary">
              {{ $t('attendanceRecord.exportRecord') }}
              <i class="el-icon-arrow-down el-icon--right"></i>
            </el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item
                icon="el-icon-download"
                command="exportSearchResult"
                >{{ $t('attendanceRecord.exportResult') }}</el-dropdown-item
              >
              <el-dropdown-item icon="el-icon-download" command="exportAll">
                {{ $t('attendanceRecord.exportAll') }}
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </el-form-item> -->
      </el-form>
    </div>
    <div class="black_panel_cla">
      <zk-table
        :data="tableData"
        :columns="columnData"
        :showTableMenu="true"
        style="min-height:300px;height: auto;"
      ></zk-table>
      <div class="pagination-margin-top">
        <el-pagination
          background
          @size-change="changePageSize"
          @current-change="changePage"
          :current-page="pager.curPage"
          :page-size="pager.pageSize"
          layout="total, prev, pager, next, sizes, jumper"
          :total="pager.total"
        ></el-pagination>
      </div>
      <verify-photo ref="verifyPhoto"></verify-photo>

      <!-- <el-dialog
        :title="$t('attendanceRecord.view')"
        :visible.sync="verifyPhotoDia"
        width="30%"
      >
        <div style="text-align:center">
          <el-image :src="verifyPhoto">
            <div slot="placeholder" class="image-slot">
              {{ $t('common.loading') }}<span class="dot">...</span>
            </div>
          </el-image>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="verifyPhotoDia = false">{{
            $t('common.yes')
          }}</el-button>
        </span>
      </el-dialog> -->
    </div>
  </div>
</template>

<script>
import { findAttRecordListByPage } from '@/services/attendanceApi.js'
import { getStartTime, getEndTime, getLanguage } from '@/utils/utils.js'
import pickerOptions from '@/utils/pickerOptions.js'
import { Loading } from 'element-ui'
export default {
  data() {
    let columns = [
      // {
      //   type: 'index'
      // },
      {
        label: this.$t('attendanceRecord.pin'),
        prop: 'pin'
      },
      {
        label: 'Sn',
        prop: 'sn'
      },
      {
        label: this.$t('attendanceRecord.checktime'),
        prop: 'iso_check_in_time'
      },
      {
        label: this.$t('attRecord.temperature'),
        prop: 'temperature',
        visiable: true,
        render: (h, params) => {
          let val =
            params.row.temperature === '' ||
            params.row.temperature === undefined ||
            params.row.temperature === '255'
              ? 'N/A'
              : params.row.temperature
          return h('span', {}, val)
        }
      },
      {
        label: this.$t('attRecord.hasMask'),
        prop: 'maskStatus',
        visiable: true,
        render: (h, params) => {
          let val = ''
          if (
            params.row.maskStatus === '' ||
            params.row.maskStatus === undefined ||
            params.row.maskStatus === '255'
          ) {
            val = 'N/A'
          } else {
            val =
              params.row.maskStatus === '0'
                ? this.$t('common.not')
                : this.$t('common.yes')
          }

          return h('span', {}, val)
        }
      },
      {
        label: this.$t('attendanceRecord.verifyPhoto'),
        prop: 'verifyPhoto',
        render: (h, params) => {
          if (params.row.verifyPhoto === undefined || params.row.verifyPhoto === '') {
            return h('span')
          } else {
            return h(
              'span',
              {
                style: {
                  color: '#4db22f',
                  cursor: 'pointer'
                },
                on: {
                  click: () => {
                    this.$refs.verifyPhoto.showPhotoDia(params.row.verifyPhoto)
                  }
                }
              },
              this.$t('attendanceRecord.view')
            )
          }
        }
      }
      // {
      //   label: this.$t('attendanceRecord.workcode'),
      //   prop: 'workcode',
      //   visiable: true,
      //   render: (h, params) => {
      //     let val = params.row.workcode === '' ? 'N/A' : params.row.workcode
      //     return h('span', {}, val)
      //   }
      // }
    ]
    return {
      pickerOptions: pickerOptions(this),
      dateValue: null,
      params: {
        pin: '',
        beginDate: '',
        deviceSn: '',
        endDate: ''
      },
      value2: [],
      tableData: [],
      columnData: columns,
      verifyPhoto: '',
      verifyPhotoDia: false
    }
  },
  mounted() {
    this.value2 = []
    let firstDate = new Date()
    firstDate.setDate(1)
    let currentData = new Date()
    this.value2.push(firstDate)
    this.value2.push(currentData)
    let loadingInstance = Loading.service({
      lock: true,
      fullscreen: true,
      text: 'Loading',
      spinner: 'el-icon-loading',
      background: 'rgba(0, 0, 0, 0.7)'
    })
    this.$nextTick(() => {
      let _self = this
      let t = setTimeout(() => {
        _self.commQuery()
        loadingInstance.close()
        clearTimeout(t)
      }, 500)
    })

    // this.commQuery()
  },
  methods: {
    handleCommand(command) {
      let beginDate =
        command === 'exportSearchResult' ? this.params.beginDate : ''
      let endDate = command === 'exportSearchResult' ? this.params.endDate : ''
      let deviceSn =
        command === 'exportSearchResult' ? this.params.deviceSn : ''
      let pin = command === 'exportSearchResult' ? this.params.pin : ''
      let type = command === 'exportSearchResult' ? '' : 'all'
      // let companyId = sessionStorage.getItem('companyId') || ''
      let lang = getLanguage()
      let isOper = sessionStorage.getItem('role') === '"developer"'
      let url = isOper
        ? `/apiv1/hr/attrecord/exportExcel?appKey=
        ${this.$root.appKey}
          &beginDate=${beginDate}&endDate=${endDate}&deviceSn=${deviceSn}&pin=${pin}&type=${type}&lang=${lang}`
        : `/apiv1/hr/attrecord/exportExcel?beginDate=${beginDate}&endDate=${endDate}&deviceSn=${deviceSn}&pin=${pin}&type=${type}&lang=${lang}`
      window.open(url)
    },
    changePage(current) {
      this.pager.curPage = current
      this.commQuery()
    },
    changePageSize(pageSize) {
      this.pager.pageSize = pageSize
      this.commQuery()
    },
    searchFn() {
      this.pager.curPage = 1

      this.commQuery()
    },
    commQuery() {
      let valueLength = this.value2 && this.value2.length === 2
      this.params.beginDate = valueLength ? getStartTime(this.value2[0]) : ''
      this.params.endDate = valueLength ? getEndTime(this.value2[1]) : ''
      if (sessionStorage.getItem('role') === '"developer"') {
        this.params.appKey = this.$root.appKey
      }
      findAttRecordListByPage({
        params: this.params,
        pager: this.pager
      })
        .then(data => {
          if (data.code === '00000000') {
            let payload = data.payload
            this.pager.total = payload.totalRecords
            this.pager.curPage = payload.curPage
            this.pager.pageSize = payload.pageSize
            this.tableData = payload.results
          } else {
            this.errorMessage(data.message)
          }
        })
        .catch(data => {
          this.errorMessage()
        })
    }
  }
}
</script>

<style lang="less" scoped></style>



// WEBPACK FOOTER //
// src/modules/enterpriseAdmin/enterpriseSetting/attendanceRecord.vue